export enum Permission {
  ConfigurableProductsModify = 'configurable_products.modify',
}
